import { useCallback, useMemo } from "react";
import { useSearchParamArray } from "./useSearchParamArray";

const TAGS_KEY = "tags";

export interface Tag {
  readonly category: string;
  readonly value: string;
}

export function useTagParams(): { tags: Tag[]; setTags: (tags: Tag[]) => void } {
  const [value, setValue] = useSearchParamArray(TAGS_KEY);

  const tags = useMemo(
    () =>
      value
        .filter((t) => t.length > 0 && t.includes("::"))
        .map((t) => t.split("::"))
        .map(([category, value]) => ({ category, value })),
    [value],
  );

  const setTags = useCallback(
    (toSave: Tag[]) => {
      setValue(toSave.map(({ category, value }) => `${category}::${value}`));
    },
    [setValue],
  );
  return { tags, setTags };
}
